(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/utils/charity.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/utils/charity.js');
"use strict";


const filterCharityById = (activeCharities, charityId) => activeCharities.find(charity => charity.charityId === charityId);
setGlobal('svs.lyckoplatsen.page_play.utils', {
  filterCharityById
});

 })(window);